module.exports = __webpack_public_path__ + "static/img/sxbqe.e0c0169.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/sxbqe.jpg
// module id = 7gkB
// module chunks = 0